export const COLORS = { red: '#EC2227', orange: '#EE6C24', gold: '#FDB716', blue: '#1F6BFF', black: '#0D0D0D', charcoal: '#1A1A1A', white: '#FFFFFF' };

export interface GradeRule { drillDuration: number; breakDuration: number; repInterval: number; minPts: number; maxPts: number; label: string }

export const GRADE_RULES: Record<string, GradeRule> = {
  'k-2':   { drillDuration: 20, breakDuration: 15, repInterval: 3200, minPts: 1, maxPts: 2, label: 'Rookie' },
  '3-5':   { drillDuration: 20, breakDuration: 15, repInterval: 2800, minPts: 1, maxPts: 3, label: 'Beginner' },
  '6-8':   { drillDuration: 20, breakDuration: 15, repInterval: 2000, minPts: 2, maxPts: 4, label: 'Intermediate' },
  '9-10':  { drillDuration: 20, breakDuration: 15, repInterval: 1600, minPts: 3, maxPts: 5, label: 'Advanced' },
  '11-12': { drillDuration: 20, breakDuration: 15, repInterval: 1200, minPts: 4, maxPts: 6, label: 'Elite' },
};

export const GRADES = [
  // { id: 'k-2',   label: 'Kindergarten - 2nd Grade' },
  { id: '3-5',   label: '3rd - 5th Grade' },
  { id: '6-8',   label: '6th - 8th Grade' },
  // { id: '9-10',  label: '9th - 10th Grade' },
  // { id: '11-12', label: '11th - 12th Grade' },
];

// Drills order, names and cues come from GET /stand/drills — no local fallback.

export const COACH_DANO_BREAK = [
  { msg: 'You got that right hand LOCKED IN! Now we\'re going side to side - stay LOW and push it FAST. Let\'s get it!', tag: 'Rest up - next drill coming!' },
  { msg: 'That\'s what I\'m TALKING about! Crossover front of body is next - ONE smooth switch. Stay sharp, stay focused!', tag: 'Breathe - you got this!' },
  { msg: 'You\'re built DIFFERENT out here! Last drill - take it BEHIND THE BACK. Trust the move, stay low. FINISH STRONG!', tag: 'One more - give everything!' },
];

export interface PlayerVideo {
  id: number;
  title: string;
  url: string;
}

export interface StatGroup {
  eventTypeId: number;
  eventTypeName: string;
  averageSkillLevel: number;    // player's target score for this specific drill
  drillVideoUrl: string | null; // video shown during live drill reps (drill_video_url)
  rules: { name: string; value: number }[];
}

export interface Player {
  name: string;
  title: string;
  rank: string;
  score: number;          // overall_average_skill_level (0-10 scale)
  overallAverage: number; // overall_average_skill_level raw (0-10)
  color: string;
  jersey: string;
  matchId: string;
  imageUrl?: string | null; // gif/image from image_url
  videos?: PlayerVideo[];   // video_urls — non-YouTube video shown before first drill
  bh: { passing: number; dribbling: number; catching: number; offHand: number };
  def: { footwork: number; effort: number; communication: number; stance: number };
  statGroups?: StatGroup[];
}

// Fallback players — real data comes from GET /stand/players/competition
export const PLAYERS: Record<string, Record<string, Player>> = {
  '3-5': {
    boy:  { name: 'Marcus',  title: 'Rising Star',    rank: '#1 Nationally',    score: 5, overallAverage: 5, color: '#EE6C24', jersey: '23', matchId: 'XO-MRC-001', bh: { passing: 5, dribbling: 6, catching: 6, offHand: 5 }, def: { footwork: 5, effort: 6, communication: 5, stance: 6 } },
    girl: { name: 'Aaliyah', title: 'Rising Star',    rank: '#1 Nationally',    score: 4, overallAverage: 4, color: '#FF3EA5', jersey: '10', matchId: 'XO-ALY-001', bh: { passing: 5, dribbling: 6, catching: 6, offHand: 5 }, def: { footwork: 5, effort: 6, communication: 5, stance: 6 } },
  },
  '6-8': {
    boy:  { name: 'Devon',   title: 'Elite Prospect', rank: 'Top 50 Recruit',   score: 6, overallAverage: 6, color: '#FDB716', jersey: '3',  matchId: 'XO-DVN-002', bh: { passing: 7, dribbling: 7, catching: 7, offHand: 6 }, def: { footwork: 7, effort: 8, communication: 6, stance: 7 } },
    girl: { name: 'Kezia',   title: 'Elite Prospect', rank: 'Top 50 Recruit',   score: 6, overallAverage: 6, color: '#FF3EA5', jersey: '21', matchId: 'XO-KZA-002', bh: { passing: 7, dribbling: 7, catching: 7, offHand: 6 }, def: { footwork: 6, effort: 8, communication: 6, stance: 7 } },
  },
  '9-10': {
    boy:  { name: 'Cam',     title: '5-Star Recruit', rank: '#3 in the Nation', score: 8, overallAverage: 8, color: '#1F6BFF', jersey: '1',  matchId: 'XO-CAM-003', bh: { passing: 7, dribbling: 9, catching: 8, offHand: 7 }, def: { footwork: 7, effort: 9, communication: 8, stance: 7 } },
    girl: { name: 'Jasmine', title: '5-Star Recruit', rank: '#3 in the Nation', score: 7, overallAverage: 7, color: '#FF3EA5', jersey: '4',  matchId: 'XO-JSM-003', bh: { passing: 7, dribbling: 8, catching: 8, offHand: 7 }, def: { footwork: 7, effort: 8, communication: 7, stance: 7 } },
  },
  '11-12': {
    boy:  { name: 'Peyton',  title: 'D1 Bound',       rank: '#1 in the State',  score: 9, overallAverage: 9, color: '#A855F7', jersey: '0',  matchId: 'XO-PYT-004', bh: { passing: 8, dribbling: 9, catching: 8, offHand: 8 }, def: { footwork: 8, effort: 9, communication: 8, stance: 8 } },
    girl: { name: 'Taylor',  title: 'D1 Bound',       rank: '#1 in the State',  score: 9, overallAverage: 9, color: '#FF3EA5', jersey: '15', matchId: 'XO-TYL-004', bh: { passing: 8, dribbling: 9, catching: 8, offHand: 8 }, def: { footwork: 8, effort: 9, communication: 8, stance: 8 } },
  },
};

export const QUOTES = [
  { text: 'I can do all things through Christ who strengthens me.', author: 'Philippians 4:13' },
  { text: 'You have to expect things of yourself before you can do them.', author: 'Michael Jordan' },
  { text: 'The most important thing is to inspire people so that they can be great.', author: 'Kobe Bryant' },
  { text: 'Stay ready so you don\'t have to get ready.', author: 'SGA' },
  { text: 'Hard work beats talent when talent doesn\'t work hard.', author: 'Tim Notke' },
  { text: 'For I know the plans I have for you - plans to prosper you.', author: 'Jeremiah 29:11' },
  { text: 'Every rep builds you.', author: 'XrossOver Sports' },
];

export function randQuote() { return QUOTES[Math.floor(Math.random() * QUOTES.length)]; }
export function randSessionId() { return 'XO-' + Math.floor(1000 + Math.random() * 9000); }

// Leaderboard comes from GET /stand/leaderboard — this is fallback only
export const MOCK_LEADERBOARD: { name: string; score: number }[] = [];
